import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { useNavigationListItem } from "@sprout/list-navigation";
import PostPageTodoList from "./PostPageTodoList";
const PostPageTodoListWithListNavigation = (props)=>{
    const { todoList , disabled , dragProvided , index =0 , pressToEdit , todoSingularAction , todoSupportedActions ,  } = props;
    const { id  } = todoList;
    const navigationListItemProvided = useNavigationListItem(String(id), useMemo(()=>({
            index,
            object: todoList
        }), [
        index,
        todoList
    ]));
    return /*#__PURE__*/ _jsx(PostPageTodoList, {
        dragProvided: dragProvided,
        navigationListItemProvided: navigationListItemProvided,
        todoList: todoList,
        disabled: disabled,
        pressToEdit: pressToEdit,
        todoSingularAction: todoSingularAction,
        todoSupportedActions: todoSupportedActions
    });
};
export default PostPageTodoListWithListNavigation;
